import React, { useRef } from 'react';
import styled from 'styled-components';
import ReoderBooking, { ReoderBookingRef } from './ModalButtonSetting/ReoderBooking';
import { useNavigate } from 'react-router-dom';
import storage from 'utils/sessionStorage';
import { verifyPinCode } from 'widgets/RequestAdminLocalPW/Callback';
import StatusBarBgColorModal, {
  IStatusBarBgColorModalRef,
} from '../../../../Filter/ChangeBgStatusColorButton/StatusBarBgColorModal';

type Props = {
  onHide?: () => void;
};

enum TypeSetting {
  REORDER = 'REORDER',
  WORKING_TIME = 'WORKING_TIME',
  COLORS = 'COLORS',
}

const ButtonSettingPopoverContent = ({ onHide }: Props) => {
  const reoderBookingRef = useRef<ReoderBookingRef>(null);
  const statusBarBgColorModalRef = useRef<IStatusBarBgColorModalRef>(null);
  const navigate = useNavigate();
  const options = [
    { icon: <ReorderIcon />, title: 'Reorder', id: TypeSetting.REORDER },
    { icon: <WorkingTimeIcon />, title: 'Working Time', id: TypeSetting.WORKING_TIME },
    { icon: <ColorsIcon />, title: 'Colors', id: TypeSetting.COLORS },
  ];

  const handleClick = (id: string) => {
    switch (id) {
      case TypeSetting.REORDER:
        reoderBookingRef.current?.open();
        onHide?.();
        break;
      case TypeSetting.WORKING_TIME:
        verifyPinCode(() => {
          navigate(`/store/${storage.shop_id.get()}/setting-service/payments?menuKey=working`);
          onHide?.();
        });
        // open sepecial modal by TypeSetting
        break;
      case TypeSetting.COLORS:
        statusBarBgColorModalRef.current?.open();
        onHide?.();
        break;
      default:
        onHide?.();
        // open sepecial modal by TypeSetting
        break;
    }
  };

  return (
    <Container>
      {options.map((item) => {
        return (
          <div className='item' key={item.id} onClick={() => handleClick(item.id)}>
            <div className='icon_box'>{item.icon}</div>
            <div className='title'>{item.title}</div>
          </div>
        );
      })}
      <ReoderBooking ref={reoderBookingRef} />
      <StatusBarBgColorModal ref={statusBarBgColorModalRef} />
    </Container>
  );
};

export default ButtonSettingPopoverContent;

const Container = styled.div`
  .item {
    cursor: pointer;
    display: flex;
    height: 64px;
    padding: 0 16px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    .icon_box {
      display: flex;
      width: 40px;
      height: 40px;
      padding: 3.753px 6.371px 3.333px 7.337px;
      justify-content: center;
      align-items: center;
      aspect-ratio: 1/1;
    }
    .title {
      color: #1d2129;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
  .item:hover {
    background: #f5f5f5;
  }
  .item:not(:last-child) {
    border-bottom: 1px solid var(--Border-02, #ccd4dc);
  }
  .item-title {
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 10px;
  }
`;

const ReorderIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='27' height='34' viewBox='0 0 27 34' fill='none'>
      <path
        d='M11.1304 1.82167C11.3441 1.87511 11.5044 1.92854 11.6647 1.98197C11.8784 2.08883 11.9853 2.30256 11.9853 2.46285V3.53147C11.9853 4.60009 11.9853 5.61528 11.9853 6.63048C11.9853 6.8442 11.6113 7.16479 11.1304 7.16479C10.0617 7.16479 9.04656 7.16479 7.97793 7.16479H6.26814H4.55834C3.91717 7.16479 3.27599 7.16479 2.63482 7.16479C2.47453 7.16479 2.31423 7.16479 2.20737 7.16479C1.77992 7.11136 1.51277 6.79077 1.51277 6.63048C1.51277 5.93587 1.51277 5.24127 1.51277 4.54666C1.51277 3.85206 1.51277 3.15745 1.51277 2.40942C1.51277 2.30255 1.61963 2.14226 1.72649 2.0354C1.83335 1.92854 2.04708 1.87511 2.2608 1.82167H11.1304ZM11.1838 0.753052H2.15394C1.72649 0.806483 1.35247 0.913345 1.03189 1.1805C0.604437 1.50109 0.33728 1.98197 0.33728 2.46285C0.33728 3.85206 0.33728 5.24127 0.33728 6.63048C0.33728 7.37851 1.08532 8.07312 1.94021 8.17998C2.15394 8.23341 2.36766 8.23341 2.52796 8.23341C3.16913 8.23341 3.8103 8.23341 4.45148 8.23341C5.62696 8.23341 6.74902 8.23341 7.9245 8.23341C8.99313 8.23341 10.0083 8.23341 11.0769 8.23341C12.0921 8.23341 13.0005 7.48537 13.0005 6.63048C13.0005 5.24127 13.0005 3.85206 13.0005 2.40942C13.0005 1.87511 12.6799 1.34079 12.199 1.02021C11.9318 0.913345 11.5578 0.806483 11.1838 0.753052Z'
        fill='#C84B31'
      />
      <path
        d='M17.4889 1.71473C17.756 1.39414 18.1835 1.23385 18.6109 1.34071C19.1452 1.44757 19.5192 2.08874 19.3589 2.62306C19.3055 2.99707 18.9849 3.42452 18.7178 3.69168C21.1222 3.69168 23.1526 3.69168 25.6104 3.69168C26.1447 3.69168 26.679 4.17256 26.6256 4.70687C26.6256 12.9887 26.6256 20.6828 26.6256 28.9646C26.6256 29.2318 26.6256 29.4989 26.5187 29.7126C26.3584 30.0867 25.9844 30.3538 25.557 30.3538C22.3511 30.3538 19.5727 30.3538 16.3668 30.3538C16.0996 30.3538 15.7791 30.3004 15.5119 30.1401C15.1379 29.8729 15.0845 29.4455 15.1913 29.1783C15.3516 28.8043 15.7256 28.5906 16.1531 28.5906C19.0918 28.5906 21.9771 28.5906 24.9158 28.5906C24.9158 20.8965 24.9158 13.2024 24.9158 5.50834C22.832 5.50834 20.7482 5.50834 18.6643 5.50834C18.8781 5.77549 19.1987 5.98922 19.3055 6.3098C19.4658 6.84412 19.1452 7.43186 18.6643 7.59215C18.2903 7.75245 17.8629 7.64558 17.5957 7.37843C16.8477 6.68382 16.1531 5.93579 15.4585 5.24118C15.0845 4.86716 15.0845 4.17256 15.4585 3.74511C16.0996 3.10394 16.7943 2.40933 17.4889 1.71473Z'
        fill='#C84B31'
      />
      <path
        d='M11.0235 12.9888V14.0574C11.2372 14.0574 11.5044 14.1108 11.6647 14.2711C11.825 14.378 11.9318 14.5917 11.9318 14.8054C11.9318 15.8206 11.9318 16.8358 11.9318 17.851V19.3471C11.9318 19.6142 11.7181 19.8814 11.451 19.9883C11.3441 20.0417 11.1838 20.0951 10.9701 20.0951H10.9166C10.2755 20.0951 9.6343 20.0951 8.99313 20.0951H7.2299H5.46667C4.39805 20.0951 3.32942 20.0951 2.31423 20.0951C1.83335 20.0951 1.45933 19.7211 1.45933 19.4005C1.45933 17.851 1.45933 16.2481 1.45933 14.6986C1.45933 14.4314 1.77992 14.0574 2.2608 14.004C2.36766 14.004 2.42109 14.004 2.52796 14.004H11.0769L11.0235 12.9888ZM11.0235 12.9888C8.13823 12.9888 5.30638 12.9888 2.47453 12.9888C2.36766 12.9888 2.2608 12.9888 2.10051 12.9888C1.13875 13.0956 0.33728 13.8437 0.33728 14.752C0.33728 16.3015 0.33728 17.9044 0.33728 19.4539C0.33728 20.3623 1.24561 21.2172 2.2608 21.2172C3.32942 21.2172 4.39805 21.2172 5.41324 21.2172C6.58872 21.2172 7.71078 21.2172 8.88626 21.2172C9.52744 21.2172 10.1686 21.2172 10.8098 21.2172C10.8632 21.2172 10.8632 21.2172 10.9166 21.2172C11.2372 21.2172 11.5578 21.1637 11.825 21.0569C12.5196 20.7897 13.0005 20.0951 12.947 19.3471C12.947 17.851 12.947 16.3015 12.947 14.8054C12.947 14.2711 12.6799 13.7368 12.2524 13.4162C11.9853 13.1491 11.5044 12.9888 11.0235 12.9888Z'
        fill='#C84B31'
      />
      <path
        d='M0.33728 27.4152C0.33728 26.5069 1.29904 25.7054 2.31423 25.7054C5.25295 25.7054 8.19166 25.7054 11.0769 25.7054C12.0921 25.7054 13.0005 26.5069 13.0005 27.4152C13.0005 28.9113 13.0005 30.4074 13.0005 31.85C13.0005 32.3309 12.7867 32.8652 12.3593 33.1858C12.0387 33.453 11.6113 33.6133 11.1838 33.6667H2.20737C1.77992 33.6133 1.35247 33.453 1.03189 33.1858C0.604437 32.8652 0.390712 32.3309 0.390712 31.85C0.33728 30.354 0.33728 28.9113 0.33728 27.4152Z'
        fill='#C84B31'
      />
    </svg>
  );
};

const WorkingTimeIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'>
      <path
        d='M15.2188 33.75H7.5C4.04875 33.75 1.25 30.9513 1.25 27.5V12.5C1.25 9.04875 4.04875 6.25 7.5 6.25H32.5C35.9512 6.25 38.75 9.04875 38.75 12.5V17.8988C38.75 18.5887 38.19 19.1488 37.5 19.1488C36.81 19.1488 36.25 18.5887 36.25 17.8988V12.5C36.25 10.4288 34.5713 8.75 32.5 8.75H7.5C5.42875 8.75 3.75 10.4288 3.75 12.5V27.5C3.75 29.5712 5.42875 31.25 7.5 31.25H15.2188C15.9088 31.25 16.4688 31.81 16.4688 32.5C16.4688 33.19 15.9088 33.75 15.2188 33.75Z'
        fill='#C84B31'
      />
      <path
        d='M27.5 8.75H12.5V5C12.5 2.9325 14.1825 1.25 16.25 1.25H23.75C25.8175 1.25 27.5 2.9325 27.5 5V8.75ZM15 6.25H25V5C25 4.31125 24.44 3.75 23.75 3.75H16.25C15.56 3.75 15 4.31125 15 5V6.25Z'
        fill='#C84B31'
      />
      <path
        d='M28.75 38.75C23.2363 38.75 18.75 34.2638 18.75 28.75C18.75 23.2363 23.2363 18.75 28.75 18.75C34.2638 18.75 38.75 23.2363 38.75 28.75C38.75 34.2638 34.2638 38.75 28.75 38.75ZM28.75 21.25C24.6137 21.25 21.25 24.6137 21.25 28.75C21.25 32.8862 24.6137 36.25 28.75 36.25C32.8862 36.25 36.25 32.8862 36.25 28.75C36.25 24.6137 32.8862 21.25 28.75 21.25Z'
        fill='#C84B31'
      />
      <path
        d='M12.01 12.3149C12.01 11.6246 11.4504 11.0649 10.76 11.0649C10.0697 11.0649 9.51001 11.6246 9.51001 12.3149V18.5649C9.51001 19.2553 10.0697 19.8149 10.76 19.8149C11.4504 19.8149 12.01 19.2553 12.01 18.5649V12.3149Z'
        fill='#C84B31'
      />
      <path
        d='M30.49 15.4399V12.3149C30.49 11.6249 29.93 11.0649 29.24 11.0649C28.55 11.0649 27.99 11.6249 27.99 12.3149V15.4399H30.49Z'
        fill='#C84B31'
      />
      <path d='M2.5 14.1899H37.5V16.6899H2.5V14.1899Z' fill='#C84B31' />
      <path
        d='M26.4562 31.1913C25.9537 30.7188 25.9287 29.9275 26.4012 29.425L27.3037 28.4638C27.43 28.33 27.4987 28.1538 27.4987 27.97V24.3738C27.4987 23.6838 28.0587 23.1238 28.7487 23.1238C29.4387 23.1238 29.9987 23.6838 29.9987 24.3738V28.41C29.9987 28.9475 29.7937 29.4638 29.4262 29.855L28.2212 31.1363C27.7487 31.6388 26.9575 31.6638 26.455 31.1913H26.4562Z'
        fill='#C84B31'
      />
      <rect x='8.20618' y='23.3422' width='6.65273' height='2.98075' rx='1.49038' fill='#C84B31' />
    </svg>
  );
};

const ColorsIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='36' height='38' viewBox='0 0 36 38' fill='none'>
      <path
        d='M9.53207 1.16824C9.69034 0.957211 10.0069 0.732996 10.2575 0.970401C15.0715 5.74487 19.8592 10.5589 24.66 15.3466C24.8447 15.5444 25.0953 15.7159 25.1348 16.006C25.214 16.3226 25.0557 16.6391 24.8183 16.837C21.1385 20.5035 17.4719 24.1833 13.7922 27.8499C13.4888 28.1796 12.9481 28.1928 12.6447 27.8631C8.95174 24.1701 5.25878 20.4772 1.56582 16.7842C1.20971 16.494 1.19652 15.8741 1.53944 15.5708C4.54657 12.5637 7.55369 9.54335 10.574 6.54941C9.65077 5.65255 8.74072 4.71612 7.81748 3.80607C7.6724 3.67418 7.55369 3.50272 7.46137 3.33126C8.05488 2.53991 8.84623 1.89364 9.53207 1.16824ZM12.9876 8.54097C10.4817 11.0733 7.94937 13.5924 5.43024 16.1115C10.6136 16.1115 15.7969 16.1247 20.9803 16.0984C18.3952 13.5133 15.8101 10.9414 13.2382 8.34314C13.1591 8.40908 13.0668 8.47503 12.9876 8.54097Z'
        fill='#C84B31'
      />
      <path
        d='M26.7043 23.3264C27.3901 22.1921 28.1947 21.137 29.0784 20.161C30.2522 21.5327 31.3733 22.9835 32.1119 24.6453C32.468 25.4367 32.6658 26.3467 32.402 27.1908C32.0327 28.6548 30.6347 29.8155 29.1047 29.7891C27.4693 29.855 25.9261 28.5625 25.6756 26.9534C25.4118 25.6609 26.0844 24.4211 26.7043 23.3264Z'
        fill='#C84B31'
      />
      <path
        d='M0.576534 33.2968C0.563345 33.0463 0.813939 32.888 1.03815 32.9276C12.3413 32.9276 23.6444 32.9276 34.9475 32.9276C35.1189 32.9012 35.2772 33.0067 35.4223 33.099C35.4355 34.3388 35.4355 35.5786 35.4223 36.8184C35.4355 37.069 35.1453 37.1349 34.9607 37.1217C23.6576 37.1217 12.3544 37.1217 1.05134 37.1217C0.787561 37.1745 0.563345 36.9634 0.589724 36.6997C0.563345 35.5522 0.563345 34.4179 0.576534 33.2968Z'
        fill='#C84B31'
      />
    </svg>
  );
};
